import { DialogContent, Tooltip } from "@material-ui/core";
import Skeleton from "react-loading-skeleton";
import React from "react";
import { ActivityItemWorker } from "services/input-core/work-items/@types";

import { useTranslation } from "react-i18next";
import { useGetPaginatedLogSystem } from "services/input-core/log-system/get-paginated-logs";
import { SubjectStatusLogSystemEnum } from "utils/@types";
import { Info } from "@material-ui/icons";
import { Box } from "@mui/material";
import { parseISO, format, isValid } from "date-fns";
import { ColumnDef } from "@tanstack/table-core";
import PaginatedTable from "components/Tables/ReactTable/ManualPaginatedTable";
import { useSowContext } from "store/sow";

const LogSystem = () => {
  const { t } = useTranslation([
    "modals",
    "log-system",
    "list-errors",
    "list-messages",
  ]);

  const activityItem = useSowContext((ctx) => ctx.activityItemDetails);

  const [tableData, setTableData] = React.useState({
    pageSize: 10,
    pageIndex: 0,
    columnFilters: [],
    sorting: [],
  });

  const paramsGetLogSystem: any = {
    limit: tableData.pageSize,
    page: tableData.pageIndex + 1,
    // ...getFilters(tableData.columnFilters),
    // ...getSorting(tableData.sorting),
  };

  const {
    data: logSystemData,
    isLoading: isLogSystemData,
  } = useGetPaginatedLogSystem({
    zID: activityItem?.zIdentifier,
    params: paramsGetLogSystem,
  });

  const dataFormatted =
    logSystemData?.docs?.map((doc) => {
      return {
        category: doc?.category ?? "",
        subcategory: doc?.subcategory ?? "",
        environment: doc?.environment ?? "",
        subjectKey:
          t(SubjectStatusLogSystemEnum[doc.subject.key], {
            ns: "log-system",
          }) ?? "",
        subjectDescription: doc.subject?.value ?? "",
        actor: doc.actor ?? "",
        timestampDate: doc.timestampDate
        ? (() => {
            const parsedDate = parseISO(doc.timestampDate);
            return isValid(parsedDate) ? format(parsedDate, "dd/MM/yyyy HH:mm:ss") : "";
          })()
        : "",
      };
    }) || [];

  const columns: ColumnDef<any, any>[] = [
    {
      header: t("react-table-column-event-date"),
      footer: (props: any) => props.column.id,
      accessorKey: "timestampDate",
    },
    {
      header: t("react-table-column-subject"),
      footer: (props: any) => props.column.id,
      accessorKey: "subjectKey",
    },
    {
      header: t("react-table-column-description"),
      footer: (props: any) => props.column.id,
      accessorKey: "subjectDescription",
      cell: ({ row }: any) => {
        return row.original?.subjectDescription == "" ? (
          "---"
        ) : (
          <Tooltip
            placement="bottom-end"
            title={
              <>
                {row.original?.subjectDescription
                  ?.split(";")
                  .map((line: any, index: number) => (
                    <p key={index}>{line}</p>
                  ))}
              </>
            }
          >
            <Box display="flex" flex={"0 1"}>
              <p
                style={{
                  width: "100%",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {row.original?.subjectDescription.replaceAll(";", "; ")}
              </p>

              <Info style={{ marginLeft: 5 }} color="disabled" />
            </Box>
          </Tooltip>
        );
      },
    },
    {
      header: t("react-table-column-actor"),
      footer: (props: any) => props.column.id,
      accessorKey: "actor",
    },
    {
      header: "",
      footer: (props: any) => props.column.id,
      accessorKey: "actions",
      enableColumnFilter: false,
    },
  ].filter((element) => element);

  const renderListLogSystemData = (isLogSystemData: boolean) => {
    return isLogSystemData ? (
      <div style={{ padding: "2rem 1rem" }}>
        <Skeleton />
      </div>
    ) : (
      <div>
        <DialogContent>
          {/* <Table columns={columns} data={dataFormatted} initialPageSize={5} /> */}
          <PaginatedTable
            columns={columns}
            data={dataFormatted || []}
            tableState={tableData}
            pageCount={logSystemData?.totalPages}
            setTableState={setTableData}
            hasFilters={false}
            // fixedPageSize
          />
        </DialogContent>
      </div>
    );
  };

  return <>{renderListLogSystemData(isLogSystemData)}</>;
};

export default LogSystem;
